
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network/ai-trainers-reviews",
      function () {
        return require("private-next-pages/network/ai-trainers-reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/network/ai-trainers-reviews"])
      });
    }
  